import {validateValue} from '../helpers/validation'

// Begin action types
export const CLEAR_MAP_CHARTS = 'CLEAR_MAP_CHARTS'
export const FETCH_MAP_CHARTS_OVERVIEW_SUCCESS = 'FETCH_MAP_CHARTS_OVERVIEW_SUCCESS'
export const FETCH_MAP_CHARTS_MANAGE_SUCCESS = 'FETCH_MAP_CHARTS_MANAGE_SUCCESS'
// End action types

export const clearMapCharts = () => ({
  type: CLEAR_MAP_CHARTS
});
export const fetchMapChartsOverviewSuccess = (overview) => ({
  type: FETCH_MAP_CHARTS_OVERVIEW_SUCCESS,
  overview
});
export const fetchMapChartsManageSuccess = (manage) => ({
  type: FETCH_MAP_CHARTS_MANAGE_SUCCESS,
  manage
});
